module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.ba18ba6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/Roboto-Bold.woff2
// module id = JKLm
// module chunks = 0